<template>
  <el-dialog
    style="z-index: 9999"
    :visible.sync="visible"
    :modal-append-to-body="false"
    :before-close="onClose"
  >
    <img width="100%" :src="imageSrc" alt="" />
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClose() {
      this.$emit("onCloseImage");
    },
  },
};
</script>
<style scoped>
.video-box {
  width: 100%;
  height: 400px;
}
</style>
